/* "Maattabel"-link naast de maatkiezer: opent de maattabel-accordeon en scrolt ernaartoe.
   De link blijft verborgen als de pagina geen maattabel heeft. */
(() => {
  const init = () => {
    document.querySelectorAll('[data-bb-size-chart-link]').forEach((button) => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      const chart = document.querySelector('details[data-bb-size-chart]');
      if (!chart) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        chart.open = true;
        const summary = chart.querySelector('summary');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        chart.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        if (summary) {
          summary.setAttribute('tabindex', '-1');
          summary.focus({ preventScroll: true });
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
